<div class="m-[16px]">
  <div class="flex justify-between items-center">
    <div class="text-[#121212] font-bold text-[16px]">
      {{ date.toLocaleString('default', { month: 'long', year: 'numeric' }) }}
    </div>
    <div class="flex">
      <button (click)="decrementMonth()" class="w-[24px] h-[24px] flex items-center justify-center rounded-[8px] hover:bg-gray-200">
        <fa-icon [icon]="faChevronLeft"/>
      </button>
      <button (click)="incrementMonth()" class="w-[24px] h-[24px] flex items-center justify-center rounded-[8px] hover:bg-gray-200">
        <fa-icon [icon]="faChevronRight"/>
      </button>
    </div>
  </div>
  <div class="grid grid-cols-7 gap-[4px] text-[#121212] text-[12px] font-medium mt-[16px] text-center">
    <div>
      <b>Sun</b>
    </div>
    <div>
      <b>Mon</b>
    </div>
    <div>
      <b>Tue</b>
    </div>
    <div>
      <b>Wed</b>
    </div>
    <div>
      <b>Thur</b>
    </div>
    <div>
      <b>Fri</b>
    </div>
    <div>
      <b>Sat</b>
    </div>
  </div>
  @for (week of calendarDays; track week) {
    <div class="grid grid-cols-7 gap-[4px] text-[#121212] text-[12px] font-medium text-center">
      @for (calendarDay of week; track calendarDay) {
        <div [ngClass]="calendarDay.isCurrentMonth? 'font-semibold w-[28px] h-[28px] transition-opacity':'text-[#637381] font-normal w-[28px] h-[28px]'">
          @if (calendarDay.exams?.length === 0) {
            <div class="rounded-[8px] w-full h-full flex justify-center items-center">
              {{calendarDay.dayNumber}}
            </div>
          }
          @if (calendarDay.exams != undefined && calendarDay.exams.length > 0) {
            <button
              (click)="toggleDropdown(calendarDay)"
        [ngClass]="calendarDay.toggleDropdown?  'rounded-[8px] text-[#CC0033] w-full h-full flex justify-center items-center bg-[#CC00334D]':
        'rounded-[8px] bg-[#CC00331A] text-[#CC0033] w-full h-full flex justify-center items-center hover:bg-[#CC00334D]'"
              >
              {{calendarDay.dayNumber}}
            </button>
          }
          @if (calendarDay.toggleDropdown) {
            <div class="calendarDropdownMenu">
              @if (calendarDay.exams != undefined) {
                <h1 class="text-[16px] font-semibold m-[12px]">
                  Assessments due {{calendarDay.exams[0].finish_by | date: 'MM/dd/y' }}
                </h1>
              }
              <div class="w-full mb-[12px]">
                @for (exam of calendarDay.exams; track exam) {
                  <button (click)="studentExamNavigateToAssessment(exam)" class="flex justify-between items-center mt-[8px] hover:bg-[#F2EFFE] w-full py-[8px] px-[12px]">
                    <div class="text-left mr-[8px]">
                      <div class="text-[14px] font-semibold">
                        {{exam.exam_title}}
                      </div>
                      <div class="text-[#637381] text-[12px] mt-[4px]">
                        {{exam.course_name}}
                      </div>
                    </div>
                    <div class="text-[#454F5B]">
                      Exam
                    </div>
                  </button>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
